import { useParams } from "react-router";
import { ItemCardLocalCombination } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardLocalCombination/ItemCardLocalCombination";
import { ItemCardDefault } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardDefault/ItemCardDefault";
import React from "react";
import { isLocalCombinationArticle } from "@coworker/app/src/components/RoomSettings/Helpers/articleHelpers";
import { ArticleType } from "@coworker/types/lib/tasks/constants";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "./SelectedItemCard.module.css";

interface SelectedItemCardProps {
  item: Item;
  setSearchHistory: (value: string[]) => void;
  searchHistory: string[];
  handleProductClick: (product: Item) => void;
}

export const SelectedItemCard = ({
  item,
  setSearchHistory,
  searchHistory,
  handleProductClick,
}: SelectedItemCardProps) => {
  const { type } = useParams<{ type: string }>();
  const isGlobalSearch = type === "global";
  const handleProductClickWrapper = () => {
    if (isGlobalSearch) {
      const normalizedName = item.name.toLowerCase();
      if (normalizedName) {
        setSearchHistory([
          normalizedName,
          ...searchHistory
            .filter((name) => name !== normalizedName)
            .slice(0, 9),
        ]);
      }
    }
    handleProductClick(item);
  };
  const isLocalCombination = isLocalCombinationArticle(
    item.type as ArticleType
  );

  return (
    <div
      onClick={handleProductClickWrapper}
      className={`${styles["item-card"]}`}
    >
      {isLocalCombination && <ItemCardLocalCombination item={item} />}
      {!isLocalCombination && <ItemCardDefault item={item} />}
    </div>
  );
};
